/** @jsxImportSource @emotion/react */

import { Card } from "components/Card";
import { UserContext } from "context/UserContext";
import { memo, useContext, useEffect } from "react";
import tw from "twin.macro";
import { Header } from "../Header";
import { PageProps } from "./Page.d";

const Page: React.FC<PageProps> = ({
  title,
  children,
  label,
  parentRoute,
  breadCrumb,
}) => {
  useEffect(() => {
    document.title = label;
  }, [label, title]);
  const { hideNav, setHideNav } = useContext(UserContext);
  return (
    <div css={[tw`flex flex-col`]}>
      <div css={[tw`sticky top-0 z-30 shrink`]}>
        <Header
          onActionSelect={() => setHideNav(!hideNav)}
          title={title}
          label={label}
          parentRoute={parentRoute}
          breadCrumb={breadCrumb}
        />
      </div>

      <div css={[tw`p-4 gap-y-4 flex flex-col grow relative`]}>
        <Card css={[tw`flex flex-col gap-y-2 `]}>{children}</Card>
      </div>
    </div>
    // </>
  );
};

export default memo(Page);
